module.exports = __webpack_public_path__ + "img/top3.15f4784d.svg";